import { ChangeDetectionStrategy, Component, Input, signal, computed, ChangeDetectorRef, inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FikoKnowledgeYonetici } from '../knowledge/FikoKnowledgeYonetici';
import { IFikoParametre, IFikoParametreGrup, ParamTip } from '../knowledge/IFikoKnowledge';

interface IGrupBolum { grup: IFikoParametreGrup | null; parametreler: IFikoParametre[]; derinlik: number; }

@Component({
  selector: 'fiko-parametre-workbench',
  standalone: true,
  imports: [CommonModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <div class="fpw" *ngIf="knowledge">
    <div class="fpw-bar">
      <span class="fpw-mod">
        <button [class.aktif]="knowledge.mode==='oto'" (click)="modSet('oto')">Otomatik</button>
        <button [class.aktif]="knowledge.mode==='manuel'" (click)="modSet('manuel')">Manuel</button>
      </span>
      <button class="fpw-guncelle" *ngIf="knowledge.mode==='manuel'" [class.kirli]="knowledge.kirliVarMi" (click)="guncelle()">Güncelle</button>
      <span class="fpw-ara">
        <input [ngModel]="ara()" (ngModelChange)="ara.set($event)" placeholder="Parametre ara…" />
        <button class="fpw-ara-temizle" *ngIf="ara()" (click)="ara.set('')" title="Temizle">✕</button>
      </span>
      <button class="fpw-grup-ekle" (click)="yeniGrupAcik.set(true)">+ Grup</button>
      <button class="fpw-ekle" (click)="ekle()">+ Parametre</button>
    </div>
    <div class="fpw-inline-form" *ngIf="yeniGrupAcik()">
      <input class="fpw-inline-input" [ngModel]="yeniGrupAd()" (ngModelChange)="yeniGrupAd.set($event)"
             placeholder="Grup adı" (keydown.enter)="grupEkle()" (keydown.escape)="grupIptal()" autofocus />
      <button class="fpw-ekle" (click)="grupEkle()">Ekle</button>
      <button class="fpw-iptal" (click)="grupIptal()">İptal</button>
    </div>

    <div class="fpw-grid">
      <div class="fpw-kafa">
        <span>Ad</span>
        <span>Tip</span>
        <span>Formül / Değer</span>
        <span class="fpw-kafa-sag">= Sonuç</span>
        <span>Açıklama</span>
        <span class="fpw-kafa-orta">⚙</span>
      </div>

      <div class="fpw-bos" *ngIf="!gruplanmis().length">{{ ara() ? 'Eşleşen parametre yok' : 'Henüz parametre yok' }}</div>

      <ng-container *ngFor="let bolum of gruplanmis(); trackBy: trackBolum">
        <div class="fpw-grup-baslik" *ngIf="bolum.grup || bolum.parametreler.length"
             [style.padding-left.px]="bolum.derinlik * 14 + 8">
          <span class="fpw-grup-ad">{{ bolum.grup ? bolum.grup.ad : 'Genel' }}</span>
          <button class="fpw-grup-sil" *ngIf="bolum.grup && !bolum.grup.featId" (click)="grupSil(bolum.grup)" title="Grubu sil">✕</button>
        </div>
        <div class="fpw-satir-grid" *ngFor="let p of bolum.parametreler; trackBy: trackById"
             [class.fpw-hata]="p.hata" [title]="p.hata || ''">
          <span class="fpw-h-ad" [style.padding-left.px]="bolum.derinlik * 14">
            <span *ngIf="p.feat" class="fpw-ad-kisa" [title]="p.ad">{{ kisaAd(p) }}</span>
            <input *ngIf="!p.feat" class="fpw-ad" [ngModel]="p.ad" (ngModelChange)="adGuncelle(p, $event)" />
          </span>
          <span class="fpw-h-tip">
            <select [ngModel]="p.tip" (ngModelChange)="tipGuncelle(p, $event)">
              <option *ngFor="let t of tipler" [ngValue]="t">{{t}}</option>
            </select>
          </span>
          <span class="fpw-h-deger">
            <input class="fpw-deger" [ngModel]="p.formul ?? p.deger"
                   (ngModelChange)="degerGuncelle(p, $event)"
                   [placeholder]="p.feat ? 'intrinsic' : ''" />
            <button class="fpw-fx-btn" [class.aktif]="p.formul" (click)="knowledge.fxAc?.(p.id)">ƒ(x)</button>
          </span>
          <span class="fpw-h-sonuc" [class.hata]="p.hata">= {{ p.deger }} {{ birimEtiket(p) }}</span>
          <span class="fpw-h-aciklama">
            <input class="fpw-aciklama" [ngModel]="p.aciklama" (ngModelChange)="aciklamaGuncelle(p, $event)" placeholder="açıklama…" />
          </span>
          <span class="fpw-h-aksiyon">
            <select class="fpw-grup-sec" [ngModel]="p.grupId ?? ''" (ngModelChange)="grupAta(p, $event)" title="Grup">
              <option value="">—</option>
              <option *ngFor="let g of gruplar()" [value]="g.id">{{ g.ad }}</option>
            </select>
            <button class="fpw-sil" *ngIf="!p.feat" (click)="sil(p)">✕</button>
          </span>
        </div>
      </ng-container>
    </div>

    <section class="fpw-bolum">
      <div class="fpw-bolum-bar">
        <strong>Tasarım Tablosu</strong>
        <button class="fpw-ekle" (click)="yeniKonfigAcik.set(true)">+ Konfig</button>
      </div>
      <div class="fpw-inline-form" *ngIf="yeniKonfigAcik()">
        <input class="fpw-inline-input" [ngModel]="yeniKonfigAd()" (ngModelChange)="yeniKonfigAd.set($event)"
               placeholder="Konfig adı" (keydown.enter)="konfigEkle()" (keydown.escape)="konfigIptal()" autofocus />
        <button class="fpw-ekle" (click)="konfigEkle()">Ekle</button>
        <button class="fpw-iptal" (click)="konfigIptal()">İptal</button>
      </div>
      <div class="fpw-bos" *ngIf="!konfigler().length">Henüz konfig yok</div>
      <div class="fpw-satir" *ngFor="let k of konfigler(); trackBy: trackById">
        <span class="fpw-satir-ad">{{ k.ad }}</span>
        <span class="fpw-satir-aksiyon">
          <button class="fpw-uygula" (click)="konfigUygula(k.id)">Uygula</button>
          <button class="fpw-sil" (click)="konfigSil(k.id)">✕</button>
        </span>
      </div>
    </section>

    <section class="fpw-bolum">
      <div class="fpw-bolum-bar">
        <strong>Kontroller</strong>
        <button class="fpw-ekle" (click)="yeniKontrolAcik.set(true)">+ Kontrol</button>
      </div>
      <div class="fpw-inline-form" *ngIf="yeniKontrolAcik()">
        <input class="fpw-inline-input" [ngModel]="yeniKontrolAd()" (ngModelChange)="yeniKontrolAd.set($event)"
               placeholder="Kontrol adı" (keydown.enter)="kontrolEkle()" (keydown.escape)="kontrolIptal()" autofocus />
        <input class="fpw-inline-input" [ngModel]="yeniKontrolIfade()" (ngModelChange)="yeniKontrolIfade.set($event)"
               placeholder="İfade (ör: delikCap < boy)" (keydown.enter)="kontrolEkle()" (keydown.escape)="kontrolIptal()" />
        <button class="fpw-ekle" (click)="kontrolEkle()">Ekle</button>
        <button class="fpw-iptal" (click)="kontrolIptal()">İptal</button>
      </div>
      <div class="fpw-bos" *ngIf="!kontrolSonuclari().length">Henüz kontrol yok</div>
      <div class="fpw-satir" *ngFor="let k of kontrolSonuclari(); trackBy: trackById">
        <span class="fpw-kontrol-info">
          <span class="fpw-satir-ad">{{ k.ad }}</span>
          <span class="fpw-kontrol-ifade">{{ k.ifade }}</span>
        </span>
        <span class="fpw-satir-aksiyon">
          <span class="fpw-rozet" [class.gecti]="k.gecti" [class.kaldi]="!k.gecti">
            {{ k.gecti ? '✓ Tamam' : '✗ ' + k.mesaj }}
          </span>
          <button class="fpw-sil" (click)="kontrolSil(k.id)">✕</button>
        </span>
      </div>
    </section>
  </div>
  `,
  styles: [`
    .fpw { color:#dbe4f0; font:500 12px/1.4 system-ui,sans-serif; max-height:60vh; overflow:auto; padding:2px; }
    .fpw-bar { display:flex; gap:6px; align-items:center; padding:6px; flex-wrap:wrap; position:sticky; top:0; z-index:3; background:rgba(8,16,26,.92); backdrop-filter:blur(4px); }
    .fpw-mod button { padding:2px 8px; border:1px solid rgba(0,200,255,.3); background:rgba(20,40,60,.7); color:#cfe6f5; cursor:pointer; border-radius:5px; transition:all .12s; }
    .fpw-mod button:hover { background:rgba(0,150,200,.4); border-color:#00d0ff; }
    .fpw-mod button.aktif { background:rgba(0,200,255,.3); border-color:#00d0ff; color:#fff; }
    .fpw-guncelle { padding:2px 8px; border:1px solid rgba(0,200,255,.3); background:rgba(20,40,60,.7); color:#cfe6f5; cursor:pointer; border-radius:5px; transition:all .12s; }
    .fpw-guncelle:hover { background:rgba(0,150,200,.4); border-color:#00d0ff; }
    .fpw-guncelle.kirli { background:rgba(20,120,80,.55); border-color:#34d399; color:#a7f3d0; animation:fpwpulse 1s infinite; }
    @keyframes fpwpulse { 50% { opacity:.6; } }
    .fpw-ara { position:relative; display:inline-flex; align-items:center; flex:1; min-width:120px; }
    .fpw-ara input { width:100%; background:rgba(0,0,0,.4); color:#fff; border:1px solid rgba(0,200,255,.3); border-radius:5px; padding:2px 22px 2px 8px; transition:border-color .12s; }
    .fpw-ara input:focus { border-color:#00d0ff; outline:none; }
    .fpw-ara input::placeholder { color:#aab8cc; }
    .fpw-ara-temizle { position:absolute; right:4px; background:transparent; border:none; color:#aab8cc; cursor:pointer; font-size:11px; }
    .fpw-ara-temizle:hover { color:#fca5a5; }

    .fpw-grid { display:flex; flex-direction:column; }
    .fpw-kafa, .fpw-satir-grid {
      display:grid;
      grid-template-columns:minmax(90px,1.3fr) minmax(72px,.8fr) minmax(110px,1.5fr) minmax(78px,.9fr) minmax(90px,1.2fr) minmax(96px,auto);
      align-items:center; gap:6px; padding:3px 6px;
    }
    .fpw-kafa { position:sticky; top:34px; z-index:2; background:rgba(10,20,32,.95); border-bottom:1px solid rgba(0,200,255,.28); }
    .fpw-kafa span { color:#7db0ff; text-transform:uppercase; font-size:9px; font-weight:800; letter-spacing:.6px; }
    .fpw-kafa-sag { text-align:right; }
    .fpw-kafa-orta { text-align:center; }
    .fpw-satir-grid { border-bottom:1px solid rgba(120,160,255,.10); transition:background .12s; }
    .fpw-satir-grid:hover { background:rgba(0,200,255,.06); }
    .fpw-grid input, .fpw-grid select { width:100%; background:rgba(0,0,0,.4); color:#fff; border:1px solid rgba(0,200,255,.3); border-radius:5px; padding:2px 5px; transition:border-color .12s; }
    .fpw-grid input:focus, .fpw-grid select:focus { border-color:#00d0ff; outline:none; }
    .fpw-grid input::placeholder { color:#aab8cc; }
    .fpw-hata { outline:1px solid #fca5a5; border-radius:5px; }

    .fpw-h-deger { position:relative; display:flex; gap:4px; align-items:center; }
    .fpw-fx-btn { flex:0 0 auto; background:rgba(20,40,60,.7); border:1px solid rgba(0,200,255,.3); color:#cfe6f5; border-radius:5px; padding:0 6px; cursor:pointer; font-style:italic; transition:all .12s; }
    .fpw-fx-btn:hover { background:rgba(0,150,200,.4); border-color:#00d0ff; }
    .fpw-fx-btn.aktif { background:rgba(0,200,255,.3); border-color:#00d0ff; color:#fff; }
    .fpw-h-sonuc { font-family:ui-monospace,monospace; color:#34d399; text-align:right; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; font-size:11px; }
    .fpw-h-sonuc.hata { color:#fca5a5; }
    .fpw-aciklama { font-size:11px; }

    .fpw-grup-ekle, .fpw-ekle { padding:2px 8px; border:1px solid rgba(0,200,255,.3); background:rgba(20,40,60,.7); color:#cfe6f5; cursor:pointer; border-radius:5px; transition:all .12s; }
    .fpw-grup-ekle:hover, .fpw-ekle:hover { background:rgba(0,150,200,.4); border-color:#00d0ff; }
    .fpw-ad-kisa { display:block; padding:2px 5px; color:#dbe4f0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .fpw-inline-form { display:flex; gap:6px; align-items:center; padding:6px; flex-wrap:wrap; }
    .fpw-inline-input { flex:1; min-width:120px; background:rgba(0,0,0,.4); color:#fff; border:1px solid rgba(0,200,255,.3); border-radius:5px; padding:2px 6px; transition:border-color .12s; }
    .fpw-inline-input:focus { border-color:#00d0ff; outline:none; }
    .fpw-inline-input::placeholder { color:#aab8cc; }
    .fpw-iptal { padding:2px 8px; border:1px solid rgba(120,30,30,.5); background:rgba(120,30,30,.5); color:#fca5a5; cursor:pointer; border-radius:5px; transition:all .12s; }
    .fpw-iptal:hover { color:#fff; border-color:#fca5a5; }

    .fpw-grup-baslik { display:flex; align-items:center; padding:4px 8px; background:rgba(0,0,0,.25); border-bottom:1px solid rgba(120,160,255,.12); }
    .fpw-grup-ad { font-weight:800; color:#7db0ff; text-transform:uppercase; font-size:10px; letter-spacing:.5px; }
    .fpw-grup-sil { margin-left:8px; background:transparent; border:none; color:#fca5a5; cursor:pointer; font-size:11px; transition:color .12s; }
    .fpw-grup-sil:hover { color:#fff; }

    .fpw-h-aksiyon { display:flex; gap:4px; align-items:center; }
    .fpw-grup-sec { width:auto !important; min-width:54px; max-width:90px; font-size:11px; }
    .fpw-sil { flex:0 0 auto; background:rgba(120,30,30,.5); border:1px solid rgba(120,30,30,.5); color:#fca5a5; cursor:pointer; border-radius:5px; padding:0 6px; transition:all .12s; }
    .fpw-sil:hover { color:#fff; border-color:#fca5a5; }

    .fpw-bolum { margin-top:10px; border-top:1px solid rgba(0,200,255,.3); padding:6px; }
    .fpw-bolum-bar { display:flex; gap:6px; align-items:center; margin-bottom:4px; }
    .fpw-bolum-bar strong { flex:1; color:#7db0ff; text-transform:uppercase; font-size:10px; font-weight:800; letter-spacing:.5px; }
    .fpw-bos { padding:8px 6px; color:#aab8cc; font-style:italic; text-align:center; }
    .fpw-satir { display:flex; align-items:center; gap:6px; padding:3px 4px; border-bottom:1px solid rgba(120,160,255,.10); transition:background .12s; }
    .fpw-satir:hover { background:rgba(0,200,255,.06); }
    .fpw-satir-ad { flex:0 0 auto; color:#dbe4f0; }
    .fpw-satir-aksiyon { margin-left:auto; display:flex; gap:6px; align-items:center; }
    .fpw-kontrol-info { display:flex; flex-direction:column; gap:1px; min-width:0; }
    .fpw-kontrol-ifade { font-size:10px; color:#aab8cc; font-family:monospace; }
    .fpw-uygula { padding:1px 8px; border:1px solid #00d0ff; background:rgba(0,200,255,.3); color:#fff; cursor:pointer; border-radius:5px; transition:all .12s; }
    .fpw-uygula:hover { background:rgba(0,150,200,.5); }
    .fpw-rozet { padding:1px 7px; border-radius:10px; font-size:10px; font-weight:700; white-space:nowrap; }
    .fpw-rozet.gecti { background:rgba(20,120,80,.55); color:#a7f3d0; border:1px solid #34d399; }
    .fpw-rozet.kaldi { background:rgba(120,30,30,.5); color:#fca5a5; border:1px solid rgba(120,30,30,.5); }
  `],
})
export class FikoParametreWorkbenchComponent implements OnInit, OnDestroy {
  private cd = inject(ChangeDetectorRef);
  @Input() knowledge!: FikoKnowledgeYonetici;
  private _abone?: () => void;
  ngOnInit(): void { this._abone = this.knowledge?.abone(() => { this.tik.update(v => v + 1); this.cd.markForCheck(); }); }
  ngOnDestroy(): void { this._abone?.(); }
  tipler: ParamTip[] = ['Uzunluk', 'Aci', 'Tamsayi', 'Reel', 'Boolean', 'Metin'];
  yeniGrupAcik = signal(false); yeniGrupAd = signal('');
  yeniKonfigAcik = signal(false); yeniKonfigAd = signal('');
  yeniKontrolAcik = signal(false); yeniKontrolAd = signal(''); yeniKontrolIfade = signal('');
  ara = signal('');
  private tik = signal(0);
  liste = computed(() => { this.tik(); return this.knowledge?.depo.parametreler ?? []; });
  gruplar = computed(() => { this.tik(); return this.knowledge?.depo.gruplar ?? []; });
  konfigler = computed(() => { this.tik(); return this.knowledge?.konfigler ?? []; });
  kontrolSonuclari = computed(() => { this.tik(); return this.knowledge?.kontrolDegerlendir() ?? []; });
  gruplanmis = computed<IGrupBolum[]>(() => {
    this.tik();
    const depo = this.knowledge?.depo;
    if (!depo) return [];
    const q = this.ara().trim().toLocaleLowerCase('tr');
    const eslesir = (p: IFikoParametre) => !q ||
      (p.ad || '').toLocaleLowerCase('tr').includes(q) ||
      (p.aciklama || '').toLocaleLowerCase('tr').includes(q);
    const params = depo.parametreler.filter(eslesir);
    const gruplar = depo.gruplar;
    const bolumler: IGrupBolum[] = [];
    const grupsuz = params.filter(p => !p.grupId || !gruplar.some(g => g.id === p.grupId));
    if (grupsuz.length) bolumler.push({ grup: null, parametreler: grupsuz, derinlik: 0 });
    const ekle = (ust: string | undefined, derinlik: number) => {
      for (const g of gruplar.filter(x => x.ustGrupId === ust)) {
        const gp = params.filter(p => p.grupId === g.id);
        if (gp.length || !q) bolumler.push({ grup: g, parametreler: gp, derinlik });
        ekle(g.id, derinlik + 1);
      }
    };
    ekle(undefined, 0);
    return bolumler;
  });
  private yenile() { this.tik.update(v => v + 1); this.cd.markForCheck(); this.knowledge?.agacDegisti?.(); }
  trackById(_: number, p: IFikoParametre) { return p.id; }
  /** intrinsic parametre kısa adı (son '\' parçası) — template'te backslash kaçışı sorunlu, TS'de yapılır. */
  kisaAd(p: IFikoParametre): string { return (p.ad || '').split('\\').pop() || p.ad; }
  /** tip → gösterim birimi (Uzunluk→mm, Aci→°, diğer→boş). */
  birimEtiket(p: IFikoParametre): string {
    if (p.birim) return p.birim;
    if (p.tip === 'Uzunluk') return 'mm';
    if (p.tip === 'Aci') return '°';
    return '';
  }
  trackBolum(_: number, b: IGrupBolum) { return b.grup?.id ?? '__genel__'; }

  modSet(m: 'oto' | 'manuel') { this.knowledge.mode = m; this.yenile(); }
  guncelle() { this.knowledge.guncelle(); this.yenile(); }
  ekle() {
    let ad = 'parametre1', i = 1; while (this.knowledge.depo.getAd(ad)) ad = 'parametre' + (++i);
    this.knowledge.depo.parametreEkle({ ad, tip: 'Reel', deger: 0 }); this.yenile();
  }
  sil(p: IFikoParametre) { this.knowledge.depo.parametreSil(p.id); this.yenile(); }
  grupEkle() { const ad = this.yeniGrupAd().trim(); if (!ad) return; this.knowledge.depo.grupEkle(ad); this.grupIptal(); this.yenile(); }
  grupIptal() { this.yeniGrupAcik.set(false); this.yeniGrupAd.set(''); }
  grupSil(g: IFikoParametreGrup) { this.knowledge.depo.grupSil(g.id); this.yenile(); }
  grupAta(p: IFikoParametre, grupId: string) { this.knowledge.depo.tasiParametre(p.id, grupId || undefined); this.yenile(); }
  adGuncelle(p: IFikoParametre, ad: string) { try { this.knowledge.depo.adDegistir(p.id, ad); } catch (e: any) { } this.yenile(); }
  aciklamaGuncelle(p: IFikoParametre, v: string) { p.aciklama = v; this.yenile(); }
  tipGuncelle(p: IFikoParametre, t: ParamTip) { p.tip = t; this.knowledge.parametreGuncelle(p.id, { deger: p.deger }); this.yenile(); }
  degerGuncelle(p: IFikoParametre, v: string) {
    const sayi = parseFloat(v);
    const formulMu = isNaN(sayi) || /[a-zA-Z(]/.test(v);
    this.knowledge.parametreGuncelle(p.id, formulMu ? { formul: v } : { deger: sayi });
    this.yenile();
  }
  konfigEkle() { const ad = this.yeniKonfigAd().trim(); if (!ad) return; this.knowledge.konfigEkle(ad); this.konfigIptal(); this.yenile(); }
  konfigIptal() { this.yeniKonfigAcik.set(false); this.yeniKonfigAd.set(''); }
  konfigUygula(id: string) { this.knowledge.konfigUygula(id); this.yenile(); }
  konfigSil(id: string) { this.knowledge.konfigSil(id); this.yenile(); }
  kontrolEkle() {
    const ad = this.yeniKontrolAd().trim(), ifade = this.yeniKontrolIfade().trim();
    if (!ad || !ifade) return;
    this.knowledge.kontrolEkle(ad, ifade); this.kontrolIptal(); this.yenile();
  }
  kontrolIptal() { this.yeniKontrolAcik.set(false); this.yeniKontrolAd.set(''); this.yeniKontrolIfade.set(''); }
  kontrolSil(id: string) { this.knowledge.kontrolSil(id); this.yenile(); }
}
